import { useCallback, useEffect, useState } from "react";
import {
  PRICE_DISPLAY,
  PRICE_DISPLAY_EVENT,
  PRICE_DISPLAY_STORAGE_KEY,
} from "@/utils/tip-odds";

const readMode = () => {
  try {
    return localStorage.getItem(PRICE_DISPLAY_STORAGE_KEY) ===
      PRICE_DISPLAY.PERCENT
      ? PRICE_DISPLAY.PERCENT
      : PRICE_DISPLAY.PRICE;
  } catch {
    return PRICE_DISPLAY.PRICE;
  }
};

/**
 * "$ price" or "odds %" for every tip list (Early Mail, Race Day tips, Late Mail).
 * One remembered choice (localStorage), kept in step across all lists on the page.
 */
export const usePriceDisplayMode = () => {
  const [mode, setMode] = useState(readMode);

  useEffect(() => {
    const sync = () => setMode(readMode());
    const onStorage = (e) => {
      if (e.key === PRICE_DISPLAY_STORAGE_KEY) sync();
    };
    window.addEventListener(PRICE_DISPLAY_EVENT, sync);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(PRICE_DISPLAY_EVENT, sync);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  const toggleMode = useCallback(() => {
    const next =
      readMode() === PRICE_DISPLAY.PERCENT
        ? PRICE_DISPLAY.PRICE
        : PRICE_DISPLAY.PERCENT;
    try {
      localStorage.setItem(PRICE_DISPLAY_STORAGE_KEY, next);
    } catch {
      // storage blocked: still switch this page
    }
    setMode(next);
    window.dispatchEvent(new Event(PRICE_DISPLAY_EVENT));
  }, []);

  return { mode, isPercent: mode === PRICE_DISPLAY.PERCENT, toggleMode };
};
